import React, { forwardRef, ReactElement } from 'react';

import classNames from 'classnames';
import { NavLink } from 'react-router-dom';

import { ITabProps } from '../Tabs/tabs.interface';

import styles from './tab.module.scss';

interface ITabInternalProps extends ITabProps {
  isActive?: boolean;
  onClick?: () => void;
  isMeasurement?: boolean;
}

const Tab = forwardRef<HTMLLIElement, ITabInternalProps>((props, ref) => {
  const { id, to, children, isActive, onClick, isMeasurement } = props;
  const tabClassnames = classNames(styles.tab, { [styles['tab--active']]: isActive });

  let control: ReactElement;
  if (isMeasurement) {
    control = (
      <span className={tabClassnames}>
        {children}
        <span className={styles.borderBottom} />
      </span>
    );
  } else if (to) {
    control = (
      <NavLink
        to={to}
        className={tabClassnames}
        activeClassName={styles['tab--active']}
        role="tab"
        aria-selected={isActive}
      >
        {children}
        <span className={styles.borderBottom} />
      </NavLink>
    );
  } else {
    control = (
      <button
        type="button"
        id={id}
        onClick={onClick}
        className={tabClassnames}
        role="tab"
        aria-selected={isActive}
      >
        {children}
        <span className={styles.borderBottom} />
      </button>
    );
  }

  return (
    <li ref={ref} className={styles.item}>
      {control}
    </li>
  );
});

Tab.displayName = 'Tab';

export { Tab };
